import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from '../../../assets/styles/componentStyles/scheduleMeetingStyles/contactItem.module.scss';

interface ContactItemProps {
    title: string, 
    desc: string, 
    btnText: string, 
    btnIcon: any,
    handleBtnClick: () => void,
} 

const ContactItem: React.FC<ContactItemProps> = (props) => {
    const {title, desc, btnText, btnIcon, handleBtnClick} = props;
    
    return (
        <Box className={styles.container}>
            <Typography className={styles.titleText}>
                {title}
            </Typography>
            <Typography className={styles.descText}>
                {desc}
            </Typography>
            <Box className={styles.btnContainer} onClick={handleBtnClick}>
                <img src={btnIcon} alt={btnText} />
                <Typography className={styles.btnText}>
                    {btnText}
                </Typography>
            </Box>
        </Box>
    )
}

export default ContactItem